import { useShouldShowStaffView } from "../../../StaffViewToggle/useShouldShowStaffView";
import { SiteTasksBox } from "../../components/SiteTasksBox";
import { updateStepStatus } from "../../updateStepStatus";
import { TenantChangeProcess } from "../TenantChangeProcess/TenantChangeProcess";
import type { TenantChange } from "../TenantChanges.types";

interface TenantChangeTaskListProps {
  tenantChanges: Array<TenantChange>;
  projectId: string | undefined;
  isUpdating: boolean;
  onUpdateProcess: (operatorChange: TenantChange) => Promise<void>;
}

function TenantChangeTaskList({
  tenantChanges,
  projectId,
  isUpdating,
  onUpdateProcess
}: TenantChangeTaskListProps) {
  const { shouldShowStaffView } = useShouldShowStaffView();

  return (
    <SiteTasksBox title="Mieterwechsel">
      {tenantChanges.map((tenantChange) => (
        <TenantChangeProcess
          isUpdating={isUpdating}
          key={tenantChange.id}
          projectId={projectId}
          shouldShowStaffView={shouldShowStaffView}
          tenantChange={tenantChange}
          onUpdateStepStatus={(change, step, status) =>
            updateStepStatus(change, step, status, onUpdateProcess)
          }
        />
      ))}
    </SiteTasksBox>
  );
}

export { TenantChangeTaskList, TenantChangeTaskListProps };
